<div class="container-artefact-approvals">
  <div class="header-section">
    <div>
      <div class="title">Manage All Users</div>
      <div class="subtitle">
        Manage platform users by viewing all accounts, updating roles, or
        restricting access to ensure proper control and governance.
      </div>
    </div>
    <div></div>
  </div>
  <div class="artefact-tab-section">
    <mat-tab-group
      [selectedIndex]="selectedTabIndex"
      mat-stretch-tabs="false"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab label="Org Admin"></mat-tab>
      <mat-tab label="Contributors"></mat-tab>
      <mat-tab label="Explorers"></mat-tab>
    </mat-tab-group>
  </div>
  <div class="artefact-filter-section">
    <div class="input-wrapper">
      <img src="assets/images/search-icon.svg" alt="search icon" />
      <input
        type="text"
        [value]="searchValue"
        [placeholder]="'Search for ' + currentTap"
        (input)="onSearchHandler($event)"
      />
    </div>
    <div style="border-left: 1px solid #e5e7eb"></div>
    <div
      class="input-wrapper filter-button cursor-pointer"
      (click)="onFilterClick()"
    >
      <img src="assets/images/filter-symbol.svg" alt="filter icon" />
      Filter
    </div>
  </div>

  <!-- filter -->
  <div>
    <app-admin-filter
      [reviewStatusOptions]="[]"
      [appliedFilters]="appliedFilters"
      (onRemoveFilter)="onRemoveFilter($event)"
      (onFilterChange)="onFilterChange($event)"
    />
  </div>

  <div class="table-container">
    <table-component
      [tableData]="userList"
      [columnList]="tableColumns"
      [menuFlag]="true"
      [menuOptions]="menuOptions"
      [isLoading]="fetching"
      (actionEvent)="handleAction($event)"
      [getCustomMenuOptions]="customMenuOptions"
    ></table-component>
    <div *ngIf="userCount > 0">
      <mat-paginator
        [length]="userCount"
        [pageSize]="limit"
        [pageIndex]="currentPage"
        [pageSizeOptions]="[5, 10, 20]"
        (page)="pageChanged($event)"
      ></mat-paginator>
    </div>
  </div>
</div>
